
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';
import { Image, Text, Button, Card, CardHeader, CardPreview, CardFooter, FluentProvider, webLightTheme } from '@fluentui/react-components';
import type { UAPPlacementComponentProps } from '../../@types';


export const AdPlacementLinkedInSingleImageBase = ({
  i18n,
  classes,

  // Placement data
  placementData,

  // Ad data props
  companyPageName,

  userProfileImageSrc,
  finalUrl,
  introductoryText,
  headline,
  callToAction,

  // State props
  // isEnabled

  // Flag props
  showHeader,

  showIntroductoryText,
  showfinalUrl,
  showFooter,
  showCompanyInFooter,

  // Customization props
  // customClassName,
  // imagePreviewHeight,
  showIntroductoryTextInFooter,
}: UAPPlacementComponentProps) => {
  const {
    placementMeta, placementCropping, imageMeta, effectiveImageUrl, effectiveImageWidth, effectiveImageHeight, expandedPlacementCropping,
  } = placementData || {};
  const { previewHeight, aspectRatio } = placementMeta || {};
  if (!placementData || !imageMeta) {
    return null;
  }

  const imagePreviewWidth = previewHeight * aspectRatio;

  const cropping = expandedPlacementCropping || placementCropping;

  const renderHeader = () => (
    <CardHeader
      className={classnames(classes.placementCardHeader)}
      image={<Image className={classnames(classes.placementLogo)} src={userProfileImageSrc} alt={i18n.getString(_TL_('User profile image'))} />}
      header={<div className={classnames(classes.placementCompanyName)}><b>{companyPageName}</b></div>}
      description={<Text className={classnames(classes.placementPromoteText)}>{i18n.getString(_TL_('Promoted'))}</Text>}
    />
  );

  const renderImage = () => (
    <div className={classnames(classes.placementImageContainer)}>
      {imageMeta && imageMeta.url && (
      <CardPreview className={classnames(classes.placementCardPreview)}>
        <CroppedImageView
          resizeImageHeight={previewHeight}
          aspectRatio={aspectRatio}
          src={effectiveImageUrl || imageMeta.url}
          originalWidth={effectiveImageWidth || imageMeta.originalWidth}
          originalHeight={effectiveImageHeight || imageMeta.originalHeight}
          SourceX={cropping && cropping.SourceX}
          SourceY={cropping && cropping.SourceY}
          SourceWidth={cropping && cropping.SourceWidth}
          SourceHeight={cropping && cropping.SourceHeight}
        />
      </CardPreview>
          )}
    </div>
  );

  const renderCallToAction = () => (
    <Button appearance="secondary" className={classnames(classes.placementCallToAction)}>
      {callToAction}
    </Button>
  );

  const renderFooter = () => (
    <CardFooter className={classnames(classes.placementCardFooter)}>
      <div>
        <Text className={classnames(classes.placementHeadline)}>{headline}</Text>
        {showfinalUrl && <Text className={classnames(classes.placementFinalUrl)}>{finalUrl}</Text>}
      </div>
      {callToAction && renderCallToAction()}
    </CardFooter>
  );

  const renderFooterWithCompany = () => (
    <CardFooter className={classnames(classes.placementCardFooter)}>
      <div><Text className={classnames(classes.placementHeadline)}>{headline}</Text></div>
      {showIntroductoryTextInFooter && <Text className={classnames(classes.placementIntroductoryText)}>{introductoryText}</Text>}
      <div className={classnames(classes.placementHeader)}>
        <div className={classnames(classes.placementCompanyMeta)}>
          <Image className={classnames(classes.placementLogo)} src={userProfileImageSrc} alt={i18n.getString(_TL_('User profile image'))} />
          <div className={classnames(classes.placementCompanyName)}>{companyPageName}</div>
        </div>
        {callToAction && renderCallToAction()}
      </div>
    </CardFooter>
  );

  return (
    <div className={classnames('ad-placement-card-preview')} style={{ width: `${imagePreviewWidth}px` }}>
      <FluentProvider theme={webLightTheme}>
        <Card className={classnames(classes.placementCard)}>

          {showHeader && renderHeader()}

          {showIntroductoryText && <Text className={classnames(classes.placementIntroductoryText)}>{introductoryText}</Text>}

          <div>
            {renderImage()}

            {showFooter && !showCompanyInFooter && renderFooter()}
            {showFooter && showCompanyInFooter && renderFooterWithCompany()}
          </div>
        </Card>
      </FluentProvider>
    </div>
  );
};

AdPlacementLinkedInSingleImageBase.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
  placementData: PropTypes.shape({}),
  companyPageName: PropTypes.string,
  userProfileImageSrc: PropTypes.string,
  finalUrl: PropTypes.string,
  introductoryText: PropTypes.string,
  headline: PropTypes.string,
  callToAction: PropTypes.string,
  showHeader: PropTypes.bool,
  showIntroductoryText: PropTypes.bool,
  showFooter: PropTypes.bool,
  showCompanyInFooter: PropTypes.bool,
  showIntroductoryTextInFooter: PropTypes.bool,
  showfinalUrl: PropTypes.bool,
};

AdPlacementLinkedInSingleImageBase.defaultProps = {
  placementData: {},
  companyPageName: undefined,
  userProfileImageSrc: undefined,
  finalUrl: undefined,
  introductoryText: undefined,
  headline: undefined,
  callToAction: undefined,
  showHeader: false,
  showIntroductoryText: false,
  showFooter: false,
  showCompanyInFooter: false,
  showIntroductoryTextInFooter: false,
  showfinalUrl: false,
};
